import { Pipe, PipeTransform } from '@angular/core';
import { PaymentFilterDateField } from '../../interfaces/payment';

@Pipe({
  name: 'paymentFilterDateField',
})
export class PaymentFilterDateFieldPipe implements PipeTransform {

  transform(value: PaymentFilterDateField): string {
    const options = {
      [PaymentFilterDateField.DUE_DATE]: 'Data vencimento',
      [PaymentFilterDateField.ISSUE_AT]: 'Data emissão',
      [PaymentFilterDateField.PAID_AT]: 'Data pagamento',
    }

    return options[value] || '---';
  }

}
